import { render, staticRenderFns } from "./LeaderboardTeamContent.vue?vue&type=template&id=8cff34e4&scoped=true&"
import script from "./LeaderboardTeamContent.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTeamContent.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTeamContent.vue?vue&type=style&index=0&id=8cff34e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cff34e4",
  null
  
)

export default component.exports